import { INSIGHT_TYPE, SOURCE } from "@/constants";
import { Insight } from "@/types/Insight";

const formatInsightValue = (str: string, { value }: Insight) => {
  if (!str) return "";
  if (!value) return str;

  return str.replaceAll(`{}`, value.toString());
};

type InsightTextProps = {
  insight: Insight;
} & React.HTMLProps<HTMLSpanElement>;

const InsightText: React.FunctionComponent<InsightTextProps> = ({
  insight,
  ...props
}) => {
  const { channel_type, type, value } = insight;
  const SINGULAR = {
    [INSIGHT_TYPE.TOPLIST_MENTIONS]: L.INSIGHT_TOPLIST_MENTIONS,
    [INSIGHT_TYPE.HIGH_REACH_MENTION]: L.INSIGHT_HIGH_REACH_MENTION,
    [INSIGHT_TYPE.POSITIVE_IMPACT]: L.INSIGHT_POSITIVE_IMPACT,
    [INSIGHT_TYPE.NEGATIVE_IMPACT]: L.INSIGHT_NEGATIVE_IMPACT,
    [INSIGHT_TYPE.MOST_MENTIONS]: L.INSIGHT_MOST_MENTIONS,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.FACEBOOK}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_FACEBOOK,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.INSTAGRAM}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_INSTAGRAM,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TWITTER}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TWITTER,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.LINKEDIN}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_LINKEDIN,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.PODCAST}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_PODCAST,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.RADIO}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_RADIO,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TIKTOK}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TIKTOK,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TV}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TV,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.YOUTUBE}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_YOUTUBE,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.NEWS}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_NEWS,
    [INSIGHT_TYPE.MORE_MENTIONS_THAN_USUAL]: L.INSIGHT_MORE_MENTIONS_THAN_USUAL,
    [INSIGHT_TYPE.MORE_CHANNELS_THAN_USUAL]: L.INSIGHT_MORE_CHANNELS_THAN_USUAL,
  };

  const PLURAL = {
    [INSIGHT_TYPE.TOPLIST_MENTIONS]: L.INSIGHT_TOPLIST_MENTIONS_PLURAL,
    [INSIGHT_TYPE.HIGH_REACH_MENTION]: L.INSIGHT_HIGH_REACH_MENTION_PLURAL,
    [INSIGHT_TYPE.POSITIVE_IMPACT]: L.INSIGHT_POSITIVE_IMPACT_PLURAL,
    [INSIGHT_TYPE.NEGATIVE_IMPACT]: L.INSIGHT_NEGATIVE_IMPACT_PLURAL,
    [INSIGHT_TYPE.MOST_MENTIONS]: L.INSIGHT_MOST_MENTIONS_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.FACEBOOK}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_FACEBOOK_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.INSTAGRAM}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_INSTAGRAM_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TWITTER}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TWITTER_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.LINKEDIN}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_LINKEDIN_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.PODCAST}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_PODCAST_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.RADIO}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_RADIO_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TIKTOK}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TIKTOK_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.TV}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_TV_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.YOUTUBE}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_YOUTUBE_PLURAL,
    [`${INSIGHT_TYPE.MOST_MENTIONS_FOR_CHANNEL_TYPE}${SOURCE.NEWS}`]:
      L.INSIGHT_MOST_MENTIONS_FOR_CHANNEL_TYPE_NEWS_PLURAL,
    [INSIGHT_TYPE.MORE_MENTIONS_THAN_USUAL]:
      L.INSIGHT_MORE_MENTIONS_THAN_USUAL_PLURAL,
    [INSIGHT_TYPE.MORE_CHANNELS_THAN_USUAL]:
      L.INSIGHT_MORE_CHANNELS_THAN_USUAL_PLURAL,
  };

  return (
    <span
      {...props}
      dangerouslySetInnerHTML={{
        __html: formatInsightValue(
          value > 1
            ? // Try getting a very specific form. where it's insight type AND channel type
              // ( most don't have this ...), fallback to the general form
              PLURAL[`${type}${channel_type || ""}`] || PLURAL[type]
            : SINGULAR[`${type}${channel_type || ""}`] || SINGULAR[type],
          insight
        ),
      }}
    />
  );
};

export default InsightText;
